<script setup>
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    nyheder: { type: Array, default: () => [] },
    overskrift: { type: String, default: 'Nyheder' },
});

const liste = computed(() => props.nyheder ?? []);
</script>

<template>
    <div v-if="liste.length" class="card border-0 shadow-sm mb-4">
        <div class="card-body p-4">
            <h4 class="card-title mb-3">{{ overskrift }}</h4>
            <div class="row g-3">
                <div v-for="a in liste" :key="a.id" class="col-12 col-md-4">
                    <Link :href="`/artikler/${a.slug}`" class="text-decoration-none">
                        <div class="fw-semibold">{{ a.navn }}</div>
                    </Link>
                    <div v-if="a.teaser" class="text-muted small mt-1">
                        {{ a.teaser.length > 120 ? a.teaser.slice(0, 120) + '...' : a.teaser }}
                    </div>
                    <div v-if="a.dato" class="text-muted small mt-1">{{ a.dato }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
